module.exports = "/images/file-doc-icon.svg?d3f3c60feedb2d77daabe98898a579d2";